import { useEffect } from "react";
import defaultProfilePicture from "@ht/shared/images/img1.jpg";
import { useHttpChatAgent } from './useHttpChatAgent';
import { IResponse } from '../../../hooks/useHttp';
import { useAppDispatch } from "../../../app/hooks";
import { unreadAgentNotification } from "../../../app/chatAgent/chatAgentSlice";

export const useFetchUnreadNotificationAgent = (
    agentUsername: string,
    limit = 3
) => {
    const dispatch = useAppDispatch();
    console.log("looking for unread chat-agent for:", agentUsername, agentUsername != "undefined")
    const unReadChatUrl = agentUsername && agentUsername != "undefined" ? `/UnreadChat/${agentUsername}/?limit=${limit}` : '';
    const { response, error, loading, chatBaseUrl } = useHttpChatAgent({
        url: unReadChatUrl,
        method: "get",
    });
    const retrieveData = (res: IResponse | undefined) => {
        const data = res?.data;
        const messages = data?.map(item => {
            return {
                roomId: item.room_id,
                messageId: item.message_id,
                message: item.message,
                messageType: item.message_type,
                messageTime: item.message_time,
                minMessageTime: item.min_message_time,
                messageFiles: item.message_files,
                messageRead: item.message_read,
                roomOwner: item.room_owner,
                senderId: item.sender_id,
                senderName: item.sender_name,
                avatar: { src: defaultProfilePicture },
                sessionId: item.session_id,
                participant: item.participant,
                isSent: true
            }
        }) ?? [];
        dispatch(unreadAgentNotification(messages));
    }
    useEffect(() => {
        retrieveData(response);
    }, [response]);

    return { error, loading, retrieveData, unReadChatUrl, chatBaseUrl };
};
